// A 1px rule. `hairline` — rgba(42,42,42,0.12), the page default. `line` — the
// solid rgb(216,216,216) used inside the auth overlay card.
export function Divider({
    tone = 'hairline',
    className = '',
}: {
    tone?: 'hairline' | 'line';
    className?: string;
}) {
    return <div className={`h-px ${tone === 'line' ? 'bg-placeholder' : 'bg-hairline'} ${className}`} />;
}

export default Divider;
